<template>
  <div class="evento-wrapper" ref="wrapperRef">
    <!-- Ramita decorativa de fondo -->
    <img
      src="@/assets/ramita.avif"
      alt="Decoración"
      class="ramita-fondo-visual"
    />

    <!-- TARJETA CEREMONIA -->
    <div ref="ceremoniaRef" class="tarjeta-evento derecha">
<p ref="tituloRef" class="titulo-evento">Civil Ceremony</p>
      <p ref="lugarRef" class="lugar">Hidden Gem of Gruene Resort and Events<br></p>
      <p ref="direccionRef" class="direccion">
        1554 Gruene Rd <br>
        New Braunfels, TX 78130, Estados Unidos
      </p>

      <!-- Carrusel de fotos -->
      <div class="carrusel-fotos" v-if="imagenesLugar.length" ref="fotoRef">
        <img :src="imagenesLugar[fotoActual]" alt="Foto del lugar" />
      </div>

      <p ref="horaRef" class="hora">5:00 PM</p>

      <a
        ref="botonRef"
        class="boton-mapa"
        href="https://maps.app.goo.gl/QNeCZeZuBYf6RXRc9"
        target="_blank"
      >Location</a>
    </div>

    <!-- Ramita decorativa central -->
    <img
      ref="ramitaRef"
      src="@/assets/ramita.avif"
      alt="Decoración"
      class="ramita-decorativa"
    />
  </div>
</template>
<script>
import { ref, onMounted } from 'vue'
import { gsap } from 'gsap'

export default {
  name: 'EventoDoble',
  setup() {
    const wrapperRef = ref(null)
    const ceremoniaRef = ref(null)
    const ramitaRef = ref(null)

    const tituloRef = ref(null)
    const lugarRef = ref(null)
    const direccionRef = ref(null)
    const fotoRef = ref(null)
    const horaRef = ref(null)
    const botonRef = ref(null)

    const imagenesLugar = [
      require('@/assets/11.webp'),
      require('@/assets/33.webp'),
      require('@/assets/22.webp')
    ]
    const fotoActual = ref(0)

    onMounted(() => {
      // GSAP animación al hacer scroll
      const observer = new IntersectionObserver((entries, obs) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const tl = gsap.timeline()

            tl.fromTo(tituloRef.value, { opacity: 0, scale: 0.7 }, { opacity: 1, scale: 1, duration: 1 })
              .fromTo(lugarRef.value, { y: 20, opacity: 0 }, { y: 0, opacity: 1 }, "-=0.4")
              .fromTo(direccionRef.value, { y: 20, opacity: 0 }, { y: 0, opacity: 1 }, "-=0.3")
              .fromTo(fotoRef.value, { opacity: 0, scale: 0.9 }, { opacity: 1, scale: 1 }, "-=0.3")
              .fromTo(horaRef.value, { y: 20, opacity: 0 }, { y: 0, opacity: 1 }, "-=0.3")
              .fromTo(botonRef.value, { scale: 0.8, opacity: 0 }, { scale: 1, opacity: 1 }, "-=0.3")
              .fromTo(ramitaRef.value, { opacity: 0, scale: 0 }, { opacity: 1, scale: 1, duration: 1 }, "-=0.5")

            obs.unobserve(entry.target)
          }
        })
      }, { threshold: 0.4 })

      if (wrapperRef.value) observer.observe(wrapperRef.value)

      // Carrusel automático
      setInterval(() => {
        fotoActual.value = (fotoActual.value + 1) % imagenesLugar.length
      }, 2000)
    })

    return {
      wrapperRef,
      ceremoniaRef,
      ramitaRef,
      tituloRef,
      lugarRef,
      direccionRef,
      fotoRef,
      horaRef,
      botonRef,
      imagenesLugar,
      fotoActual
    }
  }
}
</script>


<style scoped>
.evento-wrapper {
  padding: 80px 20px;
    margin: 0 auto;
  border-radius: 0 80px 0 80px; /* 🔸 redondea solo la esquina inferior derecha */

  background-color: #374336;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
    width: 90%; /* <-- antes no tenía ancho, ahora 90% */

  overflow: hidden;
}
.ramita-fondo-visual {
  position: absolute;
  bottom: 0;
  left: 0;
  top:-80px;
  width: 100%;
  opacity: 0.05; /* Bien tenue */
  z-index: 0;
  pointer-events: none;
}

.tarjeta-evento {
  background-color: #6e7e6a;
  color: #f5f5f5;
  width: 340px;
    min-height: 450px; /* 👈 cambia este valor según lo largo que quieras */
  position: relative; /* Necesario para posicionar el fondo */

  padding: 30px 24px;
  border-radius: 120px 120px 0 0;
  text-align: center;
  box-shadow: 0 10px 20px rgba(0,0,0,0.1);
  margin-bottom: 50px;
}

.tarjeta-evento.derecha {
  align-self: flex-end;
  margin-right: -15px;


}

.tarjeta-evento.izquierda {
  align-self: flex-start;
  margin-left: 0;
}

.titulo-evento {
  font-family: 'verde', cursive;
  font-size: 34px;
  color: #ebeed7;
      margin-top:25px;

  margin-bottom: 30px;
}

.lugar {
  font-family: 'subtitulos';
  font-size: 18px;
  text-transform: uppercase;
    margin-top:10px;

  margin-bottom: 8px;
}

.direccion {
  font-family: 'padres';
  font-size: 13px;
  margin-top:10px;
  margin-bottom: 12px;
  line-height: 1.4;
}

.hora {
  font-family: 'fa';
  font-size: 14px;
  margin-bottom: 12px;
}

.boton-mapa {
  background: #ffffff;
  color: #333;
  padding: 8px 18px;
  font-family: 'padres';
  font-weight: bold;
  text-decoration: none;
  border-radius: 20px;
  display: inline-block;
  transition: transform 0.3s ease;
}

.boton-mapa:hover {
  transform: scale(1.05);
}

.ramita-decorativa {
  width: 80px;
  height: auto;
  margin: 30px 0;
  transform-origin: center;
  opacity: 0;
}
.carrusel-fotos {
  width: 100%;
  max-width: 270px;
  height: 160px;
  margin: 0 auto 20px;
  border-radius: 20px;
  overflow: hidden;
}

.carrusel-fotos img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: opacity 0.5s ease-in-out;
  border-radius: 20px;
}

</style>
